<template>
  <v-list>
    <v-card-text v-if="profile && cards">
      <v-subheader>Мои карты<v-spacer />
      <v-btn v-if="profile.canAddBankCard" icon dark color="red lighten-1" small :disabled="false" @click="addBankCardDialog = true">
        <v-icon>add</v-icon>
      </v-btn>
      </v-subheader>
      <v-list>
        <v-select :items="cards" label="Активная карта" class="px-3"
        v-model="active" return-object item-text="cardid" item-value="cardid"
        :disabled="cards && cards.length === 1"
        ></v-select>
        <v-list-tile v-for="card in cards" :key="card.cardid">
          <v-list-tile-content>
            <v-list-tile-title>
              <span v-if="card.cardid === profile.cardid">{{card.cardid}}</span>
              <span v-else class="grey--text">{{card.cardid}}</span>
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-tooltip slot="append" bottom>
              <v-icon
                v-show="card.cardid === profile.cardid"
                slot="activator"
                small
                :class="card.blocked ? 'red--text text--darken-2' : 'blue--text'"
              >grade</v-icon>
              <span>Эта карта выбрана активной</span>
          </v-tooltip>
          </v-list-tile-action>
          <v-list-tile-action v-if="card.hasLinkedBankcard">
            <v-tooltip slot="append" bottom>
              <v-icon slot="activator" :class="card.blocked ? 'red--text text--darken-2' : 'blue--text'">credit_card</v-icon>
              <span>К этой карте привязана банковская карта</span>
            </v-tooltip>
          </v-list-tile-action>
          <v-list-tile-action>
            <v-tooltip bottom v-if="card.blocked">
              Разблокировать карту
              <template #activator="data" v-if="card.cardid === profile.cardid">
                <v-btn v-on="data.on" icon
                color="red darken-1"
                class="red--text text--darken-2"
                @click="() => unblock(card)"
                >
                <v-icon dark>lock</v-icon>
              </v-btn>
              </template>
              <template #activator="data" v-else>
                <v-btn v-on="data.on" icon flat
                class="red--text text--darken-2"
                @click="() => unblock(card)"
                >
                <v-icon dark>lock</v-icon>
              </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip bottom v-else>
              <b>Заблокировать карту.</b><br />
              Картой невозможно будет воспользоваться на проходной
              и для оплаты (кроме комплексного питания).
              <br />Действие обратимо.
              <template #activator="data">
                <v-btn v-on="data.on" icon flat color="primary"
                class="grey--text"
                @click="() => block(card)"
                >
                <v-icon>lock_open</v-icon>
              </v-btn>
              </template>
            </v-tooltip>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-card-text>
    <v-progress-linear v-else indeterminate></v-progress-linear>
    <v-dialog
      v-model="addBankCardDialog"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          Добавление банковской карты
          <v-spacer></v-spacer>
          <v-btn flat icon color="secondary" @click="closeBankCardDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="bankCardNumber"
            label="Введите номер банковской карты"
            placeholder="xxxx-xxxx-xxxx-xxxx"
            return-masked-value
            mask="####-####-####-####"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn flat color="primary" @click="closeBankCardDialog()">Отмена</v-btn>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" :disabled="bankCardNumber.length < 19" @click="addBankCard">Добавить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list>
</template>

<script>
import debounce from 'debounce'
export default {
  name: 'settings-cards',
  props: ['profile'],
  data: () => ({
    cards: null,
    active: null,
    serv: {},
    addBankCardDialog: false,
    bankCardNumber: ''
  }),
  methods: {
    async fetch () {
      const { cards } = await this.fetchCards()
      this.serv.cards = cards
      this.cards = cards
    },
    async fetchCards () {
      return this.$store.dispatch('sioRequest', {
        topic: 'cards-all',
        pl: {}
      })
    },
    async updateActive (val) {
      try {
        const { cardid } = val
        await this.$store.dispatch('confirm', `Вы действительно хотите заменить активную карту? Можно будет пользоваться только картой <b>${cardid}</b>`)
        if (this.profile.cardid === cardid) return
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'cards-choose',
          pl: val
        })
        this.$store.dispatch('snack', meta.msg)
        this.$store.dispatch('loginByToken')
      } catch (err) {
        this.$store.dispatch('snack', err)
      } finally {
        this.fetch()
      }
    },
    async block (card) {
      try {
        const { cardid } = card
        await this.$store.dispatch('confirm', `Вы действительно хотите заблокировать${cardid === this.active ? ' <b>АКТИВНУЮ</b> ' : ''} карту <b>${cardid}</b>?
        <br />Картой невозможно будет воспользоваться на проходной
        и для оплаты (кроме комплексного питания).
        <br />Действие обратимо.`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'cards-block',
          pl: card
        })
        this.$store.dispatch('snack', { msg: meta.msg, level: 'warning' })
      } catch (err) {
        this.$store.dispatch('snack', err)
      } finally {
        this.fetch()
      }
    },
    async unblock (card) {
      try {
        const { cardid } = card
        await this.$store.dispatch('confirm', `Вы действительно хотите разблокировать карту ${cardid} ?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'cards-unblock',
          pl: card
        })
        this.$store.dispatch('snack', meta.msg)
      } catch (err) {
        this.$store.dispatch('snack', err)
      } finally {
        this.fetch()
      }
    },
    async addBankCard () {
      try {
        const linkedBankcard = this.cards.find(x => x.hasLinkedBankcard === true)
        if (linkedBankcard) {
          await this.$store.dispatch('confirm', `К карте ${linkedBankcard.cardid} уже привязана банковская карта. Заменить?`)
        }
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'bankcards-add',
          pl: {
            cardnumber: this.bankCardNumber.split('-').join('')
          }
        })
        this.$store.dispatch('snack', meta.msg)
        this.fetch()
        this.closeBankCardDialog()
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
      finally {
        this.closeBankCardDialog()
      }
    },
    closeBankCardDialog () {
      this.bankCardNumber = ''
      this.addBankCardDialog = false
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    },
    // eslint-disable-next-line
    cards (val, old) {
      this.serv.active = this.profile.cardid
      this.active = this.profile.cardid
    },
    // eslint-disable-next-line
    active (val, old) {
      if (this.serv.active !== undefined && val !== this.serv.active) {
        this.syncActive(val)
      }
    }
  },
  async mounted () {
    if (this.profile) await this.fetch()
  },
  created () {
    this.syncActive = debounce(this.updateActive, 300)
  }
}
</script>
